"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreDataSecurityApplicationsWatchers = exports.coreDataSecurityApplicationsReducers = void 0;
const _idMap_1 = require("./_idMap/index.js");
const get_1 = require("./get.js");
const hide_1 = require("./hide.js");
const remove_1 = require("./remove.js");
const unhide_1 = require("./unhide.js");
const update_1 = require("./update.js");
const xuder_1 = require("@sonar-software/xuder");
const redux_1 = require("redux");
const all_1 = require("./all/index.js");
const bulk_1 = require("./bulk/index.js");
const _id_1 = require("./_id/index.js");
const objects_1 = require("./objects/index.js");
exports.coreDataSecurityApplicationsReducers = (0, redux_1.combineReducers)({
    all: all_1.coreDataSecurityApplicationsAllReducers,
    bulk: bulk_1.coreDataSecurityApplicationsBulkReducers,
    byId: _id_1.coreDataSecurityApplicationsByIdReducers,
    byIdMap: _idMap_1.corePuleApplicationsIdMapReducers,
    get: (0, xuder_1.joinReducers)([
        get_1.getCoreDataSecurityApplicationsSlice.asyncReducers,
        remove_1.removeCoreDataSecurityApplicationSyncSlice.syncReducer,
        update_1.updateCoreDataSecurityApplicationSyncSlice.syncReducer
    ], get_1.getCoreDataSecurityApplicationsSlice.asyncState),
    hide: hide_1.hideCoreDataSecurityApplicationsSlice.asyncReducers,
    objects: objects_1.coreDataSecurityApplicationsObjectsReducers,
    unhide: unhide_1.unhideCoreDataSecurityApplicationsSlice.asyncReducers
});
exports.coreDataSecurityApplicationsWatchers = (0, xuder_1.combineAllWatchers)([
    all_1.coreDataSecurityApplicationsAllWatchers,
    bulk_1.coreDataSecurityApplicationsBulkWatchers,
    _id_1.coreDataSecurityApplicationsByIdWatchers,
    objects_1.coreDataSecurityApplicationsObjectsWatchers,
    get_1.getCoreDataSecurityApplicationsSlice.asyncWatchers,
    hide_1.hideCoreDataSecurityApplicationsSlice.asyncWatchers,
    unhide_1.unhideCoreDataSecurityApplicationsSlice.asyncWatchers
]);
//# sourceMappingURL=index.js.map